import styled from 'styled-components';
import { useSelector } from 'react-redux';
import colors from '../../../constants/colors';
import AppLink from '../../../routing/helpers/AppLink';
import ModuleWidgetTemplateSwitch from './WidgetTemplates/ModuleWidgetTemplateSwitch';

const DefaultWidgetTemplate = (props) => {
  const { module, icon, route, oldRoute } = props;
  const auth = useSelector((state) => state.auth);

  if (!module) {
    return (
      <Container>
        <div
          className="c-logo"
          style={{ backgroundImage: `url("${auth.user.client.logoUrl}")` }}
        />
      </Container>
    );
  }

  if (route) {
    return (
      <Container>
        <AppLink path={route} params={{ moduleBridgeHex: module.hex }}>
          {icon && <span className="floating-icon">{icon}</span>}
          <div
            className={`grid-header ${
              module.square || !module.image ? 'full-size' : ''
            }`}
            style={
              module.cover
                ? {}
                : {
                    backgroundImage: `url("${module.image ||
                      auth.user.client.logoUrl}")`,
                  }
            }
          >
            <ModuleWidgetTemplateSwitch module={module} />
          </div>
          <div className="grid-title">
            <p>{module[module.name].name}</p>
          </div>
        </AppLink>
      </Container>
    );
  }
  if (oldRoute) {
    return (
      <Container>
        <a href={oldRoute}>
          <div
            className={`grid-header ${
              module.square || !module.image ? 'full-size' : ''
            }`}
            style={{
              backgroundImage: `url("${module.image ||
                auth.user.client.logoUrl}")`,
            }}
          />
          <div className="grid-title">
            <p>{module[module.name].name}</p>
          </div>
        </a>
      </Container>
    );
  }
};

export default DefaultWidgetTemplate;

const Container = styled.div`
  border-radius: 4px;
  position: relative;
  .c-logo {
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 200px;
    border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px ${colors.primaryLight} solid;
  }
  .floating-icon {
    position: absolute;
    bottom: 2px;
    right: 4px;
    opacity: 1;
    color: white;
  }
  a {
    text-decoration: none;
  }
  &:hover {
    .grid-title {
      p {
        margin-top: 3px;
      }
    }
    .grid-header {
      opacity: 1;
      background-size: 55%;
      &.full-size {
        background-size: 105%;
      }
    }
  }
  .grid-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    height: 200px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border: 1px ${colors.primaryLight} solid;
    border-bottom: 1px solid ${colors.primary};
    opacity: 0.8;
    transition: all ease 0.3s;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    background-color: white;
    &.full-size {
      background-size: 100%;
    }
    img {
      transition: all ease 0.3s;
      width: 120px;
      height: 120px;
      &.full-size {
        width: 200px;
        height: 2000px;
      }
    }
  }
  .grid-title {
    display: flex;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 200px;
    height: 50px;
    background: ${colors.primary};
    p {
      transition: all ease 0.3s;
      margin: 6px 10px;
      text-align: center;
      height: 35px;
      width: 180px;
      vertical-align: middle;
      color: white;
      font-size: 11px;
      font-weight: bold;
      text-transform: uppercase;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
